import { computed, ref } from 'vue'
import {useNavigationStore} from "@/stores/navigation";
import {storeToRefs} from "pinia";

export const useResizeNavigation = (options)=> {
  const navigationStore = useNavigationStore()
  const { menu } = storeToRefs(navigationStore)
  const itemsMovedToSubmenu = ref([])
  const navWrapperMobileWidth = ref(0)
  const getMenu = computed(() => menu.value)

  const removeElementMenuById = (arr, id) => {
    const objWithElementMenu = arr.findIndex((obj) => obj._id === id)
    if (objWithElementMenu > -1) {
      arr.splice(objWithElementMenu, 1)
    }
  }
  const addElementSubmenu = (item) => {
    const onlyElementWithSubmenu = menu.value.filter(el => el.submenu)
    const lastElementSubmenu = computed(() => onlyElementWithSubmenu[onlyElementWithSubmenu.length - 1].submenu)
    const findEl = lastElementSubmenu.value.find(el => el._id === item._id)
    if (!findEl) {
      lastElementSubmenu.value.unshift(item)
    }
  }
  const removeElementSubmenu = (item) =>  {
    const onlyElementWithSubmenu = menu.value.filter(el => el.submenu)
    const lastElementSubmenu = computed(() => onlyElementWithSubmenu[onlyElementWithSubmenu.length - 1].submenu)
    removeElementMenuById(lastElementSubmenu.value, item._id)
  }
  const documentElementOffsetWidth = (selector) => {
    return document.querySelector(selector) && document.querySelector(selector.toString()).offsetWidth
  }

  const hideSubmenuWhenIsMobile = () => {
    const onlySubmenu = menu.value?.filter(el => el?.submenu?.length ?? false)
    const widescreen = window.innerWidth >= 1372
    if(onlySubmenu) {
      onlySubmenu.forEach(itemMenu => {
        itemMenu.hide = !widescreen
      })
    }
  }

  const resizeNavigation = () => {
    const { navContent, navWrapper, rightMargin } = options
    hideSubmenuWhenIsMobile()
    const navContentWidth = computed(() => navContent?.value?.offsetWidth ?? 0)
    const navWrapperWidth = computed(() => navWrapper?.value?.offsetWidth ?? 0)
    const itemsHideWhenResizeNavigation = computed(
      () => menu.value.filter(el => !el.submenu && !el.hide && !el.keepInHeader).reverse())
    const lastNavigationItem = computed(() => itemsHideWhenResizeNavigation.value[0])
    const firstNavigationItem = computed(() => itemsMovedToSubmenu.value[itemsMovedToSubmenu.value.length - 1])


    if(window.innerWidth >= 1372) {
      navWrapperMobileWidth.value = navWrapperWidth.value
      if (navWrapperMobileWidth.value > (navContentWidth.value - rightMargin)) {
        const hideNavigation = () => {
          itemsMovedToSubmenu.value.push({
            ...lastNavigationItem.value, width: documentElementOffsetWidth(`#navid-${lastNavigationItem.value._id}`),
          })

          addElementSubmenu(lastNavigationItem.value)
          lastNavigationItem.value.hide = true
          const lastNavigationItemWidth = lastNavigationItem.value && documentElementOffsetWidth(`#navid-${lastNavigationItem.value._id}`)
          navWrapperMobileWidth.value = navWrapperMobileWidth.value - lastNavigationItemWidth
          if (navWrapperMobileWidth.value > (navContentWidth.value - rightMargin)) {
            hideNavigation()
          }
        }
        hideNavigation()
      }


      if (itemsMovedToSubmenu.value.length && (navWrapperMobileWidth.value + firstNavigationItem.value.width) < (navContentWidth.value - rightMargin)) {
        const showNavigation = () => {
          navWrapperMobileWidth.value = navWrapperMobileWidth.value + firstNavigationItem.value.width
          const objWithFirstNavigationItem = menu.value.find((obj) => obj._id === firstNavigationItem.value._id)
          objWithFirstNavigationItem.hide = false
          removeElementSubmenu(firstNavigationItem.value)

          removeElementMenuById(itemsMovedToSubmenu.value, firstNavigationItem.value._id)
          if (navWrapperMobileWidth.value < (navContentWidth.value - rightMargin) && itemsMovedToSubmenu.value.length) {
            showNavigation()
          }
        }
        showNavigation()
      }
    }
  }

  return { getMenu, resizeNavigation }
}
